export default function CTASection() {
  return (
    <section id="subscribe" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20paparazzi%20style%20photography%20with%20dramatic%20red%20and%20black%20color%20gradient%2C%20film%20grain%20texture%20overlay%2C%20mysterious%20backstage%20atmosphere%2C%20soft%20bokeh%20lights%20scattered%2C%20dark%20and%20moody%20tone%2C%20artistic%20abstract%20composition%2C%20no%20recognizable%20people%2C%20cinematic%20aesthetic&width=1400&height=600&seq=home-cta-bg-01&orientation=landscape"
              alt="订阅17黑料网"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/50"></div>
          </div>

          <div className="relative z-10 py-16 md:py-24 px-6 md:px-12 flex flex-col items-center text-center">
            <span className="font-label text-xs tracking-[0.2em] text-accent-400 mb-4 uppercase">
              不错过任何爆料
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-white mb-3">
              <span className="text-white">独家爆料</span>{' '}
              <span className="text-foreground-400 font-light italic">第一时间</span>{' '}
              <span className="text-white">掌握</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-300 max-w-lg mb-8 leading-relaxed">
              订阅17黑料网推送，网红塌房、黑料视频、吃瓜爆料，不错过任何热点事件
            </p>
            <div className="w-full max-w-md flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="输入您的邮箱地址"
                className="flex-1 px-5 py-3 bg-white/10 border border-white/20 rounded-full text-white placeholder:text-white/40 text-sm focus:outline-none focus:border-primary-500 focus:bg-white/15 transition-all"
              />
              <button className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-label font-semibold text-sm transition-all duration-300 whitespace-nowrap">
                订阅黑料提醒
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}